<form
    [formGroup]="basedataForm"
    (ngSubmit)="saveSupplierBaseData()"
    data-testid="t-basedata-form-1752672977568-1"
>
    <div
        class="form-elements--wrapper"
        data-testid="t-basedata-div-1752672977568-19"
    >
        <div
            class="row g-3"
            data-testid="t-basedata-div-1752672977568-18"
        >
            @if (coreService.checkAbility('read', 'supplier.id')) {
                <div
                    class="form-group col-12 col-md-6"
                    data-testid="t-basedata-div-1752672977568-1"
                >
                    <label
                        for="id"
                        class="form-label"
                        data-testid="t-basedata-label-1752672977568-1"
                        >{{ 'mws.supplierid' | i18n }}:</label
                    >
                    <input
                        type="text"
                        #id
                        id="id"
                        formControlName="id"
                        class="form-control"
                        placeholder="{{ 'mws.isgenerated' | i18n }}"
                        data-testid="t-basedata-input-1752672977568-1"
                    />
                </div>
            }
            @if (coreService.checkAbility('read', 'supplier.name')) {
                <div
                    class="form-group col-12 col-md-6"
                    data-testid="t-basedata-div-1752672977568-2"
                >
                    <oc-label
                        [forElement]="'name'"
                        [schema]="'supplier'"
                        [propertyName]="'name'"
                        [value]="'mws.suppliername' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-1"
                    ></oc-label>
                    <!--                <label for="name" class="form-label">{{'mws.suppliername' | i18n}} *:</label>-->
                    <!--                [ngClass]="basedataf.name.errors && basedataf.name.errors && !basedataf.name.errors?.required ? 'is-invalid' : ''"-->
                    <input
                        type="text"
                        #name
                        id="name"
                        formControlName="name"
                        class="form-control"
                        placeholder="{{ 'mws.suppliername' | i18n }}"
                        data-testid="t-basedata-input-1752672977568-2"
                    />
                    <oc-validator-error
                        [control]="basedataf.name"
                        [propertyName]="'name'"
                        [inputElementId]="'name'"
                        data-testid="t-basedata-oc-validator-error-1752672977568-1"
                    ></oc-validator-error>
                </div>
            }

            @if (coreService.checkAbility('read', 'supplier.description')) {
                <div
                    class="form-group col-12 col-md-6"
                    data-testid="t-basedata-div-1752672977568-3"
                >
                    <oc-label
                        [forElement]="'description'"
                        [schema]="'supplier'"
                        [propertyName]="'description'"
                        [value]="'mws.supplierdescr' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-2"
                    ></oc-label>
                    <textarea
                        class="form-control"
                        id="description"
                        #description
                        formControlName="description"
                        placeholder="{{ 'mws.supplierdescription' | i18n }}"
                        data-testid="t-basedata-textarea-1752672977568-1"
                    ></textarea>
                    <oc-validator-error
                        [control]="basedataf.description"
                        [propertyName]="'description'"
                        [inputElementId]="'description'"
                        data-testid="t-basedata-oc-validator-error-1752672977568-2"
                    ></oc-validator-error>
                </div>
            }

            @if (coreService.checkAbility('read', 'supplier.weburl')) {
                <div
                    class="form-group col-12 col-md-6"
                    data-testid="t-basedata-div-1752672977568-4"
                >
                    <oc-label
                        [forElement]="'webUrl'"
                        [schema]="'supplier'"
                        [propertyName]="'webUrl'"
                        [value]="'mws.homepage' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-3"
                    ></oc-label>
                    <input
                        type="text"
                        #webUrl
                        id="webUrl"
                        formControlName="webUrl"
                        class="form-control"
                        placeholder="www."
                        data-testid="t-basedata-input-1752672977568-3"
                    />
                    <oc-validator-error
                        [control]="basedataf.webUrl"
                        [propertyName]="'webUrl'"
                        data-testid="t-basedata-oc-validator-error-1752672977568-3"
                    ></oc-validator-error>
                </div>
            }

            @if (coreService.checkAbility('read', 'supplier.facebookurl')) {
                <div
                    class="form-group col-12 col-md-6"
                    data-testid="t-basedata-div-1752672977568-5"
                >
                    <oc-label
                        [forElement]="'facebookUrl'"
                        [schema]="'supplier'"
                        [propertyName]="'facebookUrl'"
                        [value]="'mws.facebook' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-4"
                    ></oc-label>
                    <input
                        type="text"
                        #facebookUrl
                        id="facebookUrl"
                        formControlName="facebookUrl"
                        class="form-control"
                        placeholder="{{ 'mws.facebookplaceholder' | i18n }}"
                        data-testid="t-basedata-input-1752672977568-4"
                    />
                    <oc-validator-error
                        [control]="basedataf.facebookUrl"
                        [propertyName]="'facebookUrl'"
                        [inputElementId]="'facebookUrl'"
                        data-testid="t-basedata-oc-validator-error-1752672977568-4"
                    ></oc-validator-error>
                </div>
            }

            <div
                class="form-group col-12 col-md-6"
                data-testid="t-basedata-div-1752672977568-7"
            >
                <div
                    class="select-wrapper"
                    data-testid="t-basedata-div-1752672977568-6"
                >
                    <oc-label
                        [forElement]="'externalsupplierid'"
                        [schema]="'supplier'"
                        [propertyName]="'externalSupplierId'"
                        [value]="'mws.externalsupplierid' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-5"
                    ></oc-label>

                    <input
                        type="text"
                        #externalsupplierid
                        id="externalsupplierid"
                        formControlName="externalSupplierId"
                        class="form-control"
                        placeholder=""
                        data-testid="t-basedata-input-1752672977568-5"
                    />
                    <oc-validator-error
                        [control]="basedataf.externalSupplierId"
                        [propertyName]="'externalSupplierId'"
                        [inputElementId]="'externalSupplierId'"
                        data-testid="t-basedata-oc-validator-error-1752672977568-5"
                    ></oc-validator-error>
                </div>
            </div>

            <div
                class="form-group col-12 col-md-6"
                data-testid="t-basedata-div-1752672977568-9"
            >
                <div
                    class="select-wrapper"
                    data-testid="t-basedata-div-1752672977568-8"
                >
                    <oc-label
                        [forElement]="'glnCode'"
                        [schema]="'supplier'"
                        [propertyName]="'glnCode'"
                        [value]="'mws.supplier.glncode' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-6"
                    ></oc-label>

                    <input
                        type="text"
                        #glnCode
                        id="glnCode"
                        formControlName="glnCode"
                        class="form-control"
                        placeholder=""
                        data-testid="t-basedata-input-1752672977568-6"
                    />
                    <oc-validator-error
                        [control]="basedataf.glnCode"
                        [propertyName]="'glnCode'"
                        [inputElementId]="'glnCode'"
                        data-testid="t-basedata-oc-validator-error-1752672977568-6"
                    ></oc-validator-error>
                </div>
            </div>

            <div
                class="form-group col-12 col-md-6"
                data-testid="t-basedata-div-1752672977568-11"
            >
                <div
                    class="select-wrapper"
                    data-testid="t-basedata-div-1752672977568-10"
                >
                    <oc-label
                        [forElement]="'taxNumber'"
                        [schema]="'supplier'"
                        [propertyName]="'taxNumber'"
                        [value]="'mws.taxnumber' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-7"
                    ></oc-label>

                    <input
                        type="text"
                        #taxNumber
                        id="taxNumber"
                        formControlName="taxNumber"
                        class="form-control"
                        placeholder=""
                        data-testid="t-basedata-input-1752672977568-7"
                    />
                    <oc-validator-error
                        [control]="basedataf.taxNumber"
                        [propertyName]="'taxNumber'"
                        [inputElementId]="'taxNumber'"
                        data-testid="t-basedata-oc-validator-error-1752672977568-7"
                    ></oc-validator-error>

                    <!-- TODO rausnehmen -->
                    <!--                    <div *ngIf="basedataf.taxNumber.errors" class="alert alert-danger">-->
                    <!--                        <div *ngFor="let e of basedataf.taxNumber.errors?.jsonSchemaError?.errors">-->
                    <!--                            {{e.message}}-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                </div>
            </div>

            @if (coreService.checkAbility('read', 'supplier.isregional') || coreService.checkAbility('read', 'supplier.regionaldescription')) {
                <div
                    class="col-md-6"
                    data-testid="t-basedata-div-1752672977568-15"
                >
                    <oc-label
                        [forElement]="'isRegional'"
                        [schema]="'supplier'"
                        [propertyName]="'isRegional'"
                        [value]="'mws.regionalsupplier' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-8"
                    ></oc-label>
                    <div
                        class="form-group"
                        data-testid="t-basedata-div-1752672977568-14"
                    >
                        <div
                            class="form-check checkbox-big"
                            data-testid="t-basedata-div-1752672977568-12"
                        >
                            <input
                                type="checkbox"
                                #isRegional
                                id="isRegional"
                                formControlName="isRegional"
                                class="form-check-input"
                                (change)="checkRegional($event)"
                                data-testid="t-basedata-input-1752672977568-8"
                            />
                        </div>
                        <div
                            class="input--holder"
                            data-testid="t-basedata-div-1752672977568-13"
                        >
                            <input
                                type="text"
                                #regionalDescription
                                id="regionalDescription"
                                formControlName="regionalDescription"
                                class="form-control"
                                placeholder="{{ 'mws.freetext' | i18n }}"
                                data-testid="t-basedata-input-1752672977568-9"
                            />
                            <oc-validator-error
                                [control]="basedataf.regionalDescription"
                                [propertyName]="'regionalDescription'"
                                [inputElementId]="'regionalDescription'"
                                data-testid="t-basedata-oc-validator-error-1752672977568-8"
                            ></oc-validator-error>
                        </div>
                    </div>
                </div>
            }
            @if (coreService.checkAbility('read', 'supplier.currency')) {
                <div
                    class="form-group col-12 col-md-6"
                    data-testid="t-basedata-div-1752672977568-17"
                >
                    <div
                        class="select-wrapper"
                        data-testid="t-basedata-div-1752672977568-16"
                    >
                        <oc-label
                            [forElement]="'currencyId'"
                            [schema]="'supplier'"
                            [propertyName]="'currencyId'"
                            [value]="'mws.currency' | i18n"
                            [classes]="'form-label'"
                            [showAsRequired]="true"
                            data-testid="t-basedata-oc-label-1752672977568-9"
                        ></oc-label>
                        <select
                            class="form-select"
                            #currencyId
                            id="currencyId"
                            formControlName="currencyId"
                            data-testid="t-basedata-select-1752672977568-1"
                        >
                            <option
                                [ngValue]="undefined"
                                data-testid="t-basedata-option-1752672977568-1"
                            >
                                {{ 'mws.pleasechoose' | i18n }}
                            </option>
                            @for (cur of environmentService.currencyList; track cur) {
                                <option
                                    [ngValue]="cur.id"
                                    data-testid="t-basedata-option-1752672977568-2"
                                >
                                    {{ cur.descr }}
                                </option>
                            }
                        </select>
                        <!-- BEACHTE: Hier wird der validationError nicht angezeigt, da er im supplier-Modell nicht als required markiert ist! Wg. Neuanlage nur über name -->
                        <!--          <oc-validator-error-->
                        <!--            [control]="basedataf.currencyId"-->
                        <!--            [propertyName]="'currencyId'"-->
                        <!--            [inputElementId]="'currencyId'"-->
                        <!--          ></oc-validator-error>-->
                    </div>
                </div>
            }
        </div>
    </div>

    <div
        class="form-elements--wrapper"
        data-testid="t-basedata-div-1752672977568-37"
    >
        <span
            class="h5"
            data-testid="t-basedata-span-1752672977568-1"
            >{{ 'mws.orderingmethods' | i18n }}</span
        >

        <div
            class="row g-3"
            data-testid="t-basedata-div-1752672977568-36"
        >
            @if (coreService.checkAbility('read', 'supplier.order.phone')) {
                <div
                    class="form-group col-12 col-md-6"
                    data-testid="t-basedata-div-1752672977568-23"
                >
                    <oc-label
                        [forElement]="'orderPhone'"
                        [schema]="'supplier'"
                        [propertyName]="'orderPhone'"
                        [value]="'mws.telephone' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-10"
                    ></oc-label>
                    <div
                        class="input-group"
                        data-testid="t-basedata-div-1752672977568-22"
                    >
                        <input
                            type="text"
                            class="form-control"
                            id="orderPhone"
                            formControlName="orderPhone"
                            placeholder=""
                            data-testid="t-basedata-input-1752672977568-10"
                        />
                        <div
                            class="input-group-append"
                            data-testid="t-basedata-div-1752672977568-21"
                        >
                            <div
                                class="input-group-text with-icon"
                                data-testid="t-basedata-div-1752672977568-20"
                            >
                                <i
                                    class="oc-contact-phone"
                                    data-testid="t-basedata-i-1752672977568-1"
                                ></i>
                            </div>
                        </div>
                    </div>
                    <oc-validator-error
                        [control]="basedataf.orderPhone"
                        [propertyName]="'orderPhone'"
                        [inputElementId]="'orderPhone'"
                        data-testid="t-basedata-oc-validator-error-1752672977568-9"
                    ></oc-validator-error>
                    <!--                <div *ngIf="basedataf.orderPhone.errors" class="alert alert-danger">-->
                    <!--                    <div *ngFor="let e of basedataf.orderPhone.errors?.jsonSchemaError?.errors">-->
                    <!--                        {{e.message}}-->
                    <!--                        {{e.keyword}} <span *ngIf="e.params.limit">- {{e.params.limit}}</span>-->
                    <!--                    </div>-->
                    <!--                </div>-->
                </div>
            }

            @if (coreService.checkAbility('read', 'supplier.order.email')) {
                <div
                    class="form-group col-12 col-md-6"
                    data-testid="t-basedata-div-1752672977568-27"
                >
                    <oc-label
                        [forElement]="'orderEmail'"
                        [schema]="'supplier'"
                        [propertyName]="'orderEmail'"
                        [value]="'mws.email' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-11"
                    ></oc-label>
                    <div
                        class="input-group"
                        data-testid="t-basedata-div-1752672977568-26"
                    >
                        <input
                            type="text"
                            class="form-control"
                            id="orderEmail"
                            formControlName="orderEmail"
                            placeholder=""
                            data-testid="t-basedata-input-1752672977568-11"
                        />
                        <div
                            class="input-group-append"
                            data-testid="t-basedata-div-1752672977568-25"
                        >
                            <div
                                class="input-group-text with-icon"
                                data-testid="t-basedata-div-1752672977568-24"
                            >
                                <i
                                    class="oc-letter"
                                    data-testid="t-basedata-i-1752672977568-2"
                                ></i>
                            </div>
                        </div>
                    </div>
                    <oc-validator-error
                        [control]="basedataf.orderEmail"
                        [propertyName]="'orderEmail'"
                        [inputElementId]="'orderEmail'"
                        data-testid="t-basedata-oc-validator-error-1752672977568-10"
                    ></oc-validator-error>
                </div>
            }

            @if (coreService.checkAbility('read', 'supplier.order.fax')) {
                <div
                    class="form-group col-12 col-md-6"
                    data-testid="t-basedata-div-1752672977568-31"
                >
                    <oc-label
                        [forElement]="'orderFax'"
                        [schema]="'supplier'"
                        [propertyName]="'orderFax'"
                        [value]="'mws.fax' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-12"
                    ></oc-label>
                    <div
                        class="input-group"
                        data-testid="t-basedata-div-1752672977568-30"
                    >
                        <input
                            type="text"
                            class="form-control"
                            id="orderFax"
                            formControlName="orderFax"
                            placeholder=""
                            data-testid="t-basedata-input-1752672977568-12"
                        />
                        <div
                            class="input-group-append"
                            data-testid="t-basedata-div-1752672977568-29"
                        >
                            <div
                                class="input-group-text with-icon"
                                data-testid="t-basedata-div-1752672977568-28"
                            >
                                <i
                                    class="oc-contact-fax"
                                    data-testid="t-basedata-i-1752672977568-3"
                                ></i>
                            </div>
                        </div>
                    </div>
                    <oc-validator-error
                        [control]="basedataf.orderFax"
                        [propertyName]="'orderFax'"
                        [inputElementId]="'orderFax'"
                        data-testid="t-basedata-oc-validator-error-1752672977568-11"
                    ></oc-validator-error>
                </div>
            }

            @if (coreService.checkAbility('read', 'supplier.order.weburl')) {
                <div
                    class="form-group col-12 col-md-6"
                    data-testid="t-basedata-div-1752672977568-35"
                >
                    <oc-label
                        [forElement]="'orderUrl'"
                        [schema]="'supplier'"
                        [propertyName]="'orderUrl'"
                        [value]="'mws.onlineportal' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-basedata-oc-label-1752672977568-13"
                    ></oc-label>
                    <div
                        class="input-group"
                        data-testid="t-basedata-div-1752672977568-34"
                    >
                        <input
                            type="text"
                            class="form-control"
                            formControlName="orderUrl"
                            placeholder=""
                            data-testid="t-basedata-input-1752672977568-13"
                        />
                        <div
                            class="input-group-append"
                            data-testid="t-basedata-div-1752672977568-33"
                        >
                            <div
                                class="input-group-text with-icon"
                                data-testid="t-basedata-div-1752672977568-32"
                            >
                                <i
                                    class="oc-earth"
                                    data-testid="t-basedata-i-1752672977568-4"
                                ></i>
                            </div>
                        </div>
                    </div>
                    <oc-validator-error
                        [control]="basedataf.orderUrl"
                        [propertyName]="'orderUrl'"
                        [inputElementId]="'orderUrl'"
                        data-testid="t-basedata-oc-validator-error-1752672977568-12"
                    ></oc-validator-error>
                </div>
            }
            <!-- SRK 2026-06-15  START EDI -->
            @if (isEdiPossible && coreService.checkAbility('read', 'supplier.order.isedi')) {
                <div class="col-md-6">
                    <oc-label
                        [forElement]="'isEdi'"
                        [schema]="'supplier'"
                        [propertyName]="'isEdi'"
                        [value]="'mws.edi' | i18n"
                        [classes]="'form-label'"
                    ></oc-label>
                    <div class="form-group">
                        <div class="form-check checkbox-big">
                            <input
                                type="checkbox"
                                #isEdi
                                id="isEdi"
                                formControlName="isEdi"
                                class="form-check-input"
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>

    @if (supplierService.supplierBasedata.updatable) {
        <div
            class="button-wrapper"
            data-testid="t-basedata-div-1752672977568-38"
        >
            <button
                [disabled]="!basedataForm.get('changed').touched"
                type="button"
                (click)="initFormValues()"
                attr.aria-label="{{ 'button.discard' | i18n }}"
                class="btn btn-danger"
                data-testid="t-basedata-button-1752672977568-1"
            >
                <i
                    class="oc-general-cancel"
                    data-testid="t-basedata-i-1752672977568-5"
                ></i>
            </button>
            <button
                [disabled]="!basedataForm.get('changed').touched"
                type="submit"
                attr.aria-label="{{ 'button.check' | i18n }}"
                class="btn btn-success"
                data-testid="t-basedata-button-1752672977568-2"
            >
                <i
                    class="oc-general-check"
                    data-testid="t-basedata-i-1752672977568-6"
                ></i>
            </button>
        </div>
    }
</form>

<!-- ADDRESSES -->
<!-- ADDRESSES -->
<!-- ADDRESSES -->
@if (coreService.checkAbility('execute', 'supplier.mainaddress.address')) {
    <div
        class=""
        data-testid="t-basedata-div-1752672977568-39"
    >
        <app-address
            [updateable]="supplierService.supplierBasedata?.updatable"
            [privilegeContext]="'supplier.mainaddress'"
            [headline]="'mws.baseaddress' | i18n"
            [addressData]="addressData"
            [showAddressee]="true"
            [addressee]="supplierService.supplierBasedata?.name"
            [isModal]="true"
            [showAddressType]="false"
            [showFavorite]="false"
            (onSubmit)="saveSupplierMainAddress($event)"
            data-testid="t-basedata-app-address-1752672977568-1"
        ></app-address>
    </div>
}

@if (coreService.checkAbility('execute', 'suppliercontact')) {
    <div
        class="form-elements--wrapper"
        data-testid="t-basedata-div-1752672977568-40"
    >
        <!-- CONTACTS -->
        <!-- CONTACTS -->
        <!-- CONTACTS -->
        <app-contacts
            [updateable]="supplierService.supplierBasedata.updatable"
            [contacts]="supplierService.supplierBasedata.supplierContacts"
            [supplierId]="supplierService.supplierBasedata.id"
            (onDataContact)="dataChangeSupplierContact($event)"
            (onDataContactDetail)="dataChangeSupplierContactDetail($event)"
            data-testid="t-basedata-app-contacts-1752672977568-1"
        ></app-contacts>
    </div>
}
@if (
    coreService.checkAbility('create', 'supplier.icon') ||
    coreService.checkAbility('read', 'supplier.icon') ||
    coreService.checkAbility('update', 'supplier.icon') ||
    coreService.checkAbility('delete', 'supplier.icon')
) {
    <div
        class="form-elements--wrapper"
        data-testid="t-basedata-div-1752672977568-43"
    >
        <span
            class="h5"
            data-testid="t-basedata-span-1752672977568-2"
            >{{ 'mws.logo' | i18n }}</span
        >
        <div
            class="form-group"
            data-testid="t-basedata-div-1752672977568-42"
        >
            <!-- UPLOADER -->
            <!-- UPLOADER -->
            <!-- UPLOADER -->
            @if (
                (!supplierService.supplierBasedata.supplierIconId || supplierService.supplierBasedata.supplierIconId === 0) &&
                supplierService.supplierBasedata.updatable
            ) {
                <app-uploader
                    [url]="uploadUrl"
                    [itemAlias]="'icon'"
                    [formData]="formData"
                    (setReturnValue)="setUploaderReturnValue($event)"
                    data-testid="t-basedata-app-uploader-1752672977568-1"
                ></app-uploader>
            }
            @if (supplierService.supplierBasedata.imageId) {
                <div
                    class="logo--upload"
                    data-testid="t-basedata-div-1752672977568-41"
                >
                    <!-- *ngIf="supplierService.supplierBasedata.supplierIconId>0" -->
                    <!--            <img loading="lazy" class="ui-w-140 d-inline-block" src="{{imagePath}}{{supplierService.supplierBasedata.imageId}}&language={{environmentService.appSettings.locale}}" alt="">-->
                    <img
                        loading="lazy"
                        class="ui-w-140 d-inline-block"
                        [src]="imageService.getImageUrl({ imageId: supplierService.supplierBasedata.imageId, imageFilename: undefined }, undefined)"
                        alt=""
                        data-testid="t-basedata-img-1752672977568-1"
                    />
                    @if (supplierService.supplierBasedata.updatable) {
                        <button
                            type="button"
                            class="btn btn-sm btn-danger action--btn"
                            attr.aria-label="{{ 'button.delete' | i18n }}"
                            (click)="deleteSupplierIcon()"
                            data-testid="t-basedata-button-1752672977568-3"
                        >
                            <i
                                class="oc-trash-can"
                                data-testid="t-basedata-i-1752672977568-7"
                            ></i>
                        </button>
                    }
                </div>
            }
        </div>
    </div>
}
@if (coreService.checkAbility('execute', 'supplier.bank')) {
    <div
        class="form-elements--wrapper"
        data-testid="t-basedata-div-1752672977568-44"
    >
        <!-- BANKVERBINDUNGEN -->
        <!-- BANKVERBINDUNGEN -->
        <!-- BANKVERBINDUNGEN -->
        <app-bank
            [updateable]="supplierService.supplierBasedata.updatable"
            [privilegeContext]="'supplier'"
            [banks]="supplierService.supplierBasedata.supplierBanks"
            (dataChangeBank)="dataChangeBank($event)"
            data-testid="t-basedata-app-bank-1752672977568-1"
        ></app-bank>
    </div>
}
